// extracted by mini-css-extract-plugin
module.exports = {"lang-select":"LanguageSelector_lang-select__4FR-B"};